module.exports = __webpack_public_path__ + "img/receive.32a254a6.png";